query TagCategories(
  $first: Int
  $after: Cursor
  $orderBy: [TagCategoriesOrderBy!]
) {
  tagCategories(first: $first, after: $after, orderBy: $orderBy) {
    nodes {
      id
      _rowTimestamp
      isCustomerMetric
      isCostMetric
      isEmployeeMetric
      isPayablesMetric
      isEnvironmentalMetric
      isPayrollMetric
      isPettyCashMetric
      isPurchasingMetric
      isRedFlag
      isReceivablesMetric
      isSupplierMetric
      isTravelMetric
      isVendorMetric
      name
      description
      _isUpdatable
      _isModified
      _isDeprecated
      _isDeletable
      _isActive
      tagCategoryItemsByTagCategoryId {
        nodes {
          _rowTimestamp
          id
          tagId
          _tagBadgeName
          tag {
            badgeColor
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
